export const userConstants = {
  LOGOUT: 'LOGOUT',
  SET_LOADING: 'SET_LOADING',
  SET_USER: 'SET_USER',
  SET_USER_CURRENCY: 'SET_USER_CURRENCY',
  UPDATE_SUBSCRIPTION: 'UPDATE_SUBSCRIPTION',
};
